







import {Component, Vue, Prop} from "vue-property-decorator";

@Component
export default class QuizResult extends Vue{
  @Prop() private question_num!: number;
  @Prop() private correct_answer_num!: number;
}
